import { gql } from '@apollo/client';

export const GET_BLOCKING_OBJECTS = gql`
  query BlockingObjects($patientId: ID!, $careTeamIds: [ID!]!) {
    user {
      patient {
        careTeamBlockingObjects(
          patientId: $patientId
          careTeamIds: $careTeamIds
        ) {
          appointments {
            id
            title
            startDate
            endDate
            eventType
            practitionerParticipants {
              practitioner {
                firstName
                lastName
                id
              }
            }
          }
          requestGroups {
            id
            title
          }
          patientGroups {
            id
            title
          }
          planDefinitions {
            id
            title
          }
        }
      }
    }
  }
`;
